import React from "react";
import SectionHeader from "../components/section/SectionHeader";
import NewOrganizationForm from "../components/organization/NewOrganizationForm";
import { CREATE_ORG_TRANSLATIONS } from "../translations/util";

const NewOrganisation = () => {
  return (
    <>
      <SectionHeader
        pageTitle={CREATE_ORG_TRANSLATIONS.header}
        // pageTitle={translations.ORG.ORG_CREATE.header}
        pageDescription={CREATE_ORG_TRANSLATIONS.headerSubtext}
        showBackButton
        sideComponent={<div className="dropdown-details" />}
      />

      <div className="main-content">
        <NewOrganizationForm />
      </div>
    </>
  );
};

export default NewOrganisation;
